import { c as _c } from "react/compiler-runtime";
import { runtimeConfig } from "@src/runtime-config";
import { Link } from "@flat-ui";
import { contactSupport } from "@utils/email-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Creates a simple component to show a link to contact support */
export function SphereSupportLink(t0) {
  const $ = _c(3);
  const {
    location
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== location || $[1] !== trackEvent) {
    t1 = <Link component="button" onClick={() => contactSupport({
      location,
      trackEvent
    })}>{runtimeConfig.mailSupportAddress}</Link>;
    $[0] = location;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}